import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import {
  Breadcrumb,
  BreadcrumbItem,
  Card,
  Col,
  Container,
  Row,
  Button,
  Table
} from "reactstrap";
import _, { lowerFirst, reverse } from "lodash";
import { parse } from "json2csv";

import closeIcon from "../../assets/images/team-reports/close-icon.png";

import teamBg from "../../assets/images/team-reports/team-bg.png";
import threeDots from "../../assets/images/team-reports/three-dots-blue.png";
import downArrow from "../../assets/images/team-reports/down-arrow.png";
import axios from "axios";
import Socket from "../../socket/socket";
import * as optAction from "../../redux/opt/action";
import SideBarTabs from "../landingLibrary/sideBarTabs";

import { compose } from "redux";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import moment from "moment";
import { Auth } from "aws-amplify";
import * as loaderAction from "../../redux/loader/action";

const TeamReports = (props) => {
  const hideTeamReports = false;

  const [apiData, setApiData] = useState([]);
  const [sortedArrayByDate, setSortedArrayByDate] = useState([]);
  const [firstTopCard, setFirstTopCard] = useState(true);
  const [secondTopCard, setSecondTopCard] = useState(true);
  const [thirdTopCard, setThirdTopCard] = useState(true);
  const [dropdowntoggle, setDropdownToggle] = useState(false);

  const [dropdownLabel, setDropdownLabel] = useState("Last 7 Days");
  const [membersObject, setMembersObject] = useState({});
  const [graphsOnLoad, setGraphsOnLoad] = useState(false);
  const [showInviteButton, setShowInviteButton] = useState(true);
  const [shareLinkModal, setShareLinkModal] = useState(false);
  const [IviteLink, setIviteLink] = useState("");
  const [magicLinkState, setmagicLinkState] = useState(false);
  const [csvData, setCsvData] = useState([]);
  console.log(csvData, "csvDatacsvDatacsvDatacsvData");

  const datesDropdownArray = _.get(
    props,
    "gameReducer.gamesData.reports.date_dropdown"
  );
  const reportCardsTop = _.get(
    props,
    "gameReducer.gamesData.reports.report_cards"
  );

  const currentUserTeamCode = _.get(props, "gameReducer.currentUser.team.id");

  const current_user = _.get(props, "gameReducer.currentUser");
  const team = _.get(current_user, "team");
  const teamCode = _.get(team, "id");

  let currentDate = new Date();
  const handle_opt_get = (res) => {
    if (res) {
      props.set_team_opts(res.team_opts);
      props.setIsLoading(false);
      props.history.push("/outside_team_building");
    }
  };

  const handle_opt_get_error = () => {
    props.setIsLoading(false);
  };

  const [dropdownOpen, setDropdownOpen] = useState(false);
  useEffect(() => {
    return Socket.addListener("opt-get", handle_opt_get, handle_opt_get_error);
  }, []);
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  useEffect(() => {
    if (
      graphsOnLoad &&
      !!apiData &&
      apiData.length > 0 &&
      apiData[0]?.CUSTDB_ENGAGEMENT.length > 0
    ) {
      filterDates("Last 7 Days");
      setGraphsOnLoad(false);
    }
  }, [graphsOnLoad, apiData]);
  const handleOptClick = () => {
    props.setIsLoading(true);
    let data = {
      action: "opt-get",
      team_code: teamCode
    };
    Socket.sendMessage(data);
  };

  useEffect(() => {
    var cognitoUser = Auth.userPool.getCurrentUser();
    if (cognitoUser !== null && current_user?.team !== undefined) {
      console.log(
        `${process.env.REACT_APP_GET_TEAM_REPORTS}/?team_code=${currentUserTeamCode}`,
        "Yugaaaaa"
      );
      axios
        .get(
          // `${process.env.REACT_APP_GET_TEAM_REPORTS}/?team_code=LIME`
          `${process.env.REACT_APP_GET_TEAM_REPORTS}/?team_code=${currentUserTeamCode}`
          // `${process.env.REACT_APP_GET_TEAM_REPORTS}/?team_code=${currentUserTeamCode}`
        )
        .then((res) => {
          console.log(res, "resrerere");
          // let y = res?.data?.data[0]?.CUSTDB_ENGAGEMENT.forEach((oneDay) => {
          //   tempDateArray.push(oneDay.DATE);
          // });

          setApiData(res?.data?.data);
          setGraphsOnLoad(true);
          sortArrayByDate(res?.data);
          TeamMembersActivity(res?.data?.data);
        });
    } else {
      props.history.push("/no-team");
    }

    // setAllDatesArray(tempDateArray);
  }, []);

  //handle Filter data For first 6 Months
  const filterReportsData = (selectedOption) => {
    let filteredDates = [];
    const filteredLables = [];
    if (selectedOption === "Last 7 Days") {
      for (let i = 1; i < 8; i++) {
        var subtractedDate = moment(currentDate)
          .subtract(i, "days")
          .format("YYYY-MM-DD");
        filteredDates.push(subtractedDate);
      }
    }
    if (selectedOption === "Last 30 Days") {
      for (let i = 1; i < 31; i++) {
        var subtractedDate = moment(currentDate)
          .subtract(i, "days")
          .format("YYYY-MM-DD");

        filteredDates.push(subtractedDate);
      }
    }
    if (selectedOption === "Last 90 Days") {
      for (let i = 1; i < 91; i++) {
        var subtractedDate = moment(currentDate)
          .subtract(i, "days")
          .format("YYYY-MM-DD");

        filteredDates.push(subtractedDate);
      }
    }
    if (selectedOption === "Last Week") {
      const last14Dates = [];

      for (let i = 1; i < 15; i++) {
        var subtractedDate = moment(currentDate)
          .subtract(i, "days")
          .format("ddd YYYY-MM-DD");

        last14Dates.push(subtractedDate);
      }
      // let currentDay = last14Dates[13];
      // let numSunday = 0;
      let i = 13;
      while (true) {
        if (last14Dates[i].includes("Sun")) {
          break;
        }
        i--;
      }

      const lastWeek = last14Dates.slice(i - 7, i);
      for (let item of lastWeek) {
        filteredDates.push(moment(item).format("YYYY-MM-DD"));
      }
    }

    for (let i = 0; i < filteredDates.length; i++) {
      let tempFiltered = moment(filteredDates[i]).format("MMM Do");
      filteredLables.push(tempFiltered);
    }
    const reverseFilteredLables_ = [...filteredLables].reverse();
    console.log(filteredLables, "reverseFilteredLables_");

    setOptions({
      labels: reverseFilteredLables_
    });

    filterDataDateWise(filteredDates, selectedOption);

    if (selectedOption === "Last Month") {
      var subtractedDate = moment(currentDate).format("YYYY-MM-DD");
      let monthIndex = parseInt(subtractedDate[5] + subtractedDate[6]);
      if (monthIndex === 1) {
        monthIndex = 12;
      }
      filterDataMonthWise(monthIndex);
    }

    if (selectedOption === "Last 90 Days") {
      let res = [];
      let index = 0;
      console.log(filteredLables, "filteredLablesfilteredLables");
      while (index <= 90) {
        if (index + 5 <= 90) {
          res.push(`${filteredLables[index]} - ${filteredLables[index + 5]}`);
        }
        index += 6;
      }
      const reverseFilteredLables = [...res].reverse();
      console.log(
        reverseFilteredLables,
        "reverseFilteredLablesreverseFilteredLablesreverseFilteredLablesreverseFilteredLablesreverseFilteredLables"
      );
      setOptions({
        labels: reverseFilteredLables
        // labels: reverseRes,
      });
    }
  };
  const sortArrayByDate = (data) => {
    let arr = [[], [], [], [], [], [], [], [], [], [], [], []];
    let yugal = data.data[0]?.CUSTDB_ENGAGEMENT.forEach((element) => {
      const date = new Date(element.DATE).getMonth();
      console.log(date, "date======>>>>");
      arr[date].push(element);
    });

    setSortedArrayByDate(arr);
    averageByMonth(arr);
  };

  const TeamMembersActivity = (apiDataa) => {
    const membersObject = {};
    const membersArray = apiDataa[3]?.CUSTDB_MEMBERS;
    for (let item of membersArray) {
      if (!!membersObject[item.NAME]) {
        membersObject[item.NAME].ACTIVITIES_RAW += item.ACTIVITIES_RAW;
        membersObject[item.NAME].TIME_RAW += item.TIME_RAW;
      } else {
        membersObject[item.NAME] = item;
      }
    }
    setMembersObject(membersObject);
  };

  const handleExport = () => {
    props.setIsLoading(true);
    axios
      .get(
        // `https://dmp3yci3ik.execute-api.us-east-1.amazonaws.com/apptest/exportTeamReport/?team_code=${currentUserTeamCode}`
        `https://dmp3yci3ik.execute-api.us-east-1.amazonaws.com/apptest/exportTeamReport/?team_code=LIME`
      )
      .then((res) => {
        console.log(res, "resrerere====>>");
        setCsvData(parse(res.data.data));
        const resDataCSV = parse(res.data);
        console.log(resDataCSV, "resData");

        const element = document.createElement("a");

        element.setAttribute(
          "href",
          `data:text/csv;charset=utf-8,${parse(res.data.data)}`
        );
        element.setAttribute("download", "TeamReports.csv");
        element.style.display = "none";

        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
        props.setIsLoading(false);
      })
      .catch(() => {
        console.log("ERROR");
        props.setIsLoading(false);
      });
  };
  const averageByMonth = (data) => {
    let avgNumActivitiesArray = [];
    let avgNumMinutesArray = [];
    let activitiesSum = 0;
    let minutesSum = 0;
    for (var i = 0; i < data.length; i++) {
      var element = data[i];
      for (var j = 0; j < element.length; j++) {
        var elementInside = element[j];
        activitiesSum = activitiesSum + elementInside?.ACTIVITIES;
        minutesSum = minutesSum + elementInside?.MINUTES;
      }
      let avgValueActivities = activitiesSum / element.length || 0;

      let avgValueMinutes = minutesSum / element.length || 0;

      avgNumActivitiesArray.push(avgValueActivities);

      avgNumMinutesArray.push(avgValueMinutes);
    }
  };

  const handleClickDropdown = (element) => {
    setDropdownLabel(element);
    setDropdownToggle(!dropdowntoggle);
  };

  const filterDates = (selectedOption) => {
    let filteredDates = [];
    const filteredLables = [];
    if (selectedOption === "Last 7 Days") {
      for (let i = 1; i < 8; i++) {
        var subtractedDate = moment(currentDate)
          .subtract(i, "days")
          .format("YYYY-MM-DD");
        filteredDates.push(subtractedDate);
      }
    }
    if (selectedOption === "Last 30 Days") {
      for (let i = 1; i < 31; i++) {
        var subtractedDate = moment(currentDate)
          .subtract(i, "days")
          .format("YYYY-MM-DD");

        filteredDates.push(subtractedDate);
      }
    }
    if (selectedOption === "Last 90 Days") {
      for (let i = 1; i < 91; i++) {
        var subtractedDate = moment(currentDate)
          .subtract(i, "days")
          .format("YYYY-MM-DD");

        filteredDates.push(subtractedDate);
      }
    }
    if (selectedOption === "Last Week") {
      const last14Dates = [];

      for (let i = 1; i < 15; i++) {
        var subtractedDate = moment(currentDate)
          .subtract(i, "days")
          .format("ddd YYYY-MM-DD");

        last14Dates.push(subtractedDate);
      }
      // let currentDay = last14Dates[13];
      // let numSunday = 0;
      let i = 13;
      while (true) {
        if (last14Dates[i].includes("Sun")) {
          break;
        }
        i--;
      }

      const lastWeek = last14Dates.slice(i - 7, i);
      for (let item of lastWeek) {
        filteredDates.push(moment(item).format("YYYY-MM-DD"));
      }
    }

    for (let i = 0; i < filteredDates.length; i++) {
      let tempFiltered = moment(filteredDates[i]).format("MMM Do");
      filteredLables.push(tempFiltered);
    }
    const reverseFilteredLables_ = [...filteredLables].reverse();
    console.log(filteredLables, "reverseFilteredLables_");

    setOptions({
      labels: reverseFilteredLables_
    });

    filterDataDateWise(filteredDates, selectedOption);

    if (selectedOption === "Last Month") {
      var subtractedDate = moment(currentDate).format("YYYY-MM-DD");
      let monthIndex = parseInt(subtractedDate[5] + subtractedDate[6]);
      if (monthIndex === 1) {
        monthIndex = 12;
      }
      filterDataMonthWise(monthIndex);
    }

    if (selectedOption === "Last 90 Days") {
      let res = [];
      let index = 0;
      console.log(filteredLables, "filteredLablesfilteredLables");
      while (index <= 90) {
        if (index + 5 <= 90) {
          res.push(`${filteredLables[index]} - ${filteredLables[index + 5]}`);
        }
        index += 6;
      }
      const reverseFilteredLables = [...res].reverse();
      console.log(
        reverseFilteredLables,
        "reverseFilteredLablesreverseFilteredLablesreverseFilteredLablesreverseFilteredLablesreverseFilteredLables"
      );
      setOptions({
        labels: reverseFilteredLables
        // labels: reverseRes,
      });
    }
  };
  const filterDataDateWise = (filteredDates, selectedOption) => {
    let filteredObject = [];
    const filteredActivities = [];
    const filteredMinutes = [];

    const filteredObjectGraph2 = [];
    const filteredObjectGraph3 = [];
    const plotGraph3 = {};
    let labelsGraph3 = [];
    let plotValuesGraph3 = [];
    const plotGraph2 = {
      COMPETITIVE: 0,
      COOPERATIVE: 0,
      GET_TO_KNOW: 0,
      TEAMWORK: 0,
      WELLNESS: 0
    };

    for (let i = 0; i < filteredDates.length; i++) {
      const filteredDataDateWise = apiData[0]?.CUSTDB_ENGAGEMENT.filter(
        (object) => object.DATE === filteredDates[i]
      );

      const filterOneObjectGraph3 = apiData[1]?.CUSTDB_FAVORITES.filter(
        (element) => element?.ROOM_CREATED_DT === filteredDates[i]
      );
      const filterOneObjectGraph2 = apiData[2]?.CUSTDB_RADAR.filter(
        (elementt) => elementt?.ROOM_CREATED_DT === filteredDates[i]
      );

      filteredActivities.push(filteredDataDateWise[0]?.ACTIVITIES);

      filteredMinutes.push(filteredDataDateWise[0]?.MINUTES);

      filteredObject.push(filteredDataDateWise[0]);
      if (filterOneObjectGraph3.length !== 0) {
        filteredObjectGraph3.push(filterOneObjectGraph3[0]);
      }
      if (filterOneObjectGraph2.length !== 0) {
        filteredObjectGraph2.push(filterOneObjectGraph2[0]);
      }
    }

    filteredObjectGraph3.forEach((data) => {
      if (!!plotGraph3[data.ACTIVITY]) {
        plotGraph3[data.ACTIVITY] += data.COUNT_TOTAL;
      } else {
        plotGraph3[data.ACTIVITY] = data.COUNT_TOTAL;
      }
    });

    let temp = Object.entries(plotGraph3);

    temp = temp.sort((a, b) => b[1] - a[1]);
    console.log(temp, "temptemp");
    const t1 = temp.map((item) => item[0]);
    const t2 = temp.map((item) => item[1]);

    console.log(t1, "temptemptemptemp");
    console.log(t2, "temptemptemptemptemptemp");
    filteredObjectGraph2.forEach((data) => {
      const temp = Object.keys(data);
      temp.forEach((key) => {
        if (
          key === "COMPETITIVE" ||
          key === "COOPERATIVE" ||
          key === "GET_TO_KNOW" ||
          key === "TEAMWORK" ||
          key === "WELLNESS"
        ) {
          plotGraph2[key] += data[key];
        }
      });
    });

    labelsGraph3 = t1;
    plotValuesGraph3 = t2;

    setSeriesGraph2([
      {
        data: Object.values(plotGraph2)
      }
    ]);
    setOptionsGraph3({
      ...optionsGraph3,
      xaxis: { ...optionsGraph3.xaxis, categories: labelsGraph3 }
    });
    setSeriesGraph3([
      {
        data: plotValuesGraph3
      }
    ]);

    const FinalFilteredActivities = filteredActivities.map((element) =>
      element === undefined ? 0 : element
    );
    const FinalFilteredMinutes = filteredMinutes.map((element) =>
      element === undefined ? 0 : element
    );
    const reverseFilteredActivities = [...FinalFilteredActivities].reverse();
    const reverseFilteredMinutes = [...FinalFilteredMinutes].reverse();

    console.log(
      reverseFilteredMinutes,
      "reverseFilteredMinutesreverseFilteredMinutes1111"
    );
    setSeries(
      series.map((activity) => {
        if (activity.type === "column") {
          return { ...activity, data: reverseFilteredActivities };
        } else {
          return { ...activity, data: reverseFilteredMinutes };
        }
      })
    );

    if (selectedOption === "Last 90 Days") {
      console.log(filteredActivities, "seriesseriesseries");
      let sum111 = filteredActivities[0];
      let tempppp111 = [];
      let sum222 = filteredMinutes[0];
      let tempppp222 = [];
      let index = 1;
      while (index <= 90) {
        if (index % 6 == 0) {
          tempppp111.push(sum111 % 6);
          sum111 = 0;
          tempppp222.push(sum222 % 6);
          sum222 = 0;
        } else {
          sum111 += filteredActivities[index];
          sum222 += filteredMinutes[index];
        }
        index += 1;
      }
      const FilteredActivities90Days = tempppp111.map((element) =>
        isNaN(element) ? 0 : element
      );
      const FilteredMinutes90Days = tempppp222.map((element) =>
        isNaN(element) ? 0 : element
      );
      const reverseTemp111 = [...FilteredActivities90Days].reverse();
      const reverseTemp222 = [...FilteredMinutes90Days].reverse();
      console.log(
        reverseTemp222,
        "reverseFilteredMinutesreverseFilteredMinutes222"
      );
      setSeries(
        series.map((activity) => {
          if (activity.type === "column") {
            return { ...activity, data: reverseTemp111 };
          } else {
            return { ...activity, data: reverseTemp222 };
          }
        })
      );
    }
  };
  const filterDataMonthWise = (filteredDates) => {
    const filteredLables = [];
    const filteredActivities = [];
    const filteredMinutes = [];
    const filteredObjectGraph3 = [];
    const filteredObjectGraph2 = [];
    const plotGraph3 = {};
    let labelsGraph3 = [];
    let plotValuesGraph3 = [];
    const plotGraph2 = {
      COMPETITIVE: 0,
      COOPERATIVE: 0,
      GET_TO_KNOW: 0,
      TEAMWORK: 0,
      WELLNESS: 0
    };
    console.log(
      sortedArrayByDate,
      "sortedArrayByDatesortedArrayByDatesortedArrayByDate"
    );

    const filteredDataMonthWise = sortedArrayByDate?.find((object, index) => {
      console.log(index, filteredDates, "filterfilter");
      if (index + 2 == filteredDates) {
        return true;
      } else {
        return false;
      }
    });

    const uniqueDates = {};
    const filteredArr = filteredDataMonthWise.filter((obj) => {
      const currentYear = new Date().getFullYear();
      const objYear = new Date(obj.DATE).getFullYear();
      const currentMonth = new Date().getMonth();
      console.log(objYear >= currentYear, "objectYear=====>>>");
      if (
        currentMonth === 1
          ? objYear >= currentYear - 1
          : objYear >= currentYear && !uniqueDates[obj.DATE]
      ) {
        uniqueDates[obj.DATE] = true;
        return true;
      }
      return false;
    });

    const today = moment();
    const lastMonth = moment().subtract(1, "month");

    const daysInLastMonth = lastMonth.daysInMonth();
    const lastMonthDates = [];

    for (let i = 1; i <= daysInLastMonth; i++) {
      const date = moment(`${lastMonth.format("YYYY-MM")}-${i}`, "YYYY-MM-DD");
      lastMonthDates.push(date.format("MMM Do"));
    }

    for (let i = 0; i < filteredDataMonthWise.length; i++) {
      const filterOneObjectGraph3 = apiData[1]?.CUSTDB_FAVORITES.filter(
        (element) => element?.ROOM_CREATED_DT === filteredDataMonthWise[i].DATE
      );
      const filterOneObjectGraph2 = apiData[2]?.CUSTDB_RADAR.filter(
        (elementt) =>
          elementt?.ROOM_CREATED_DT === filteredDataMonthWise[i].DATE
      );
      if (filterOneObjectGraph3.length !== 0) {
        filteredObjectGraph3.push(filterOneObjectGraph3[0]);
      }
      if (filterOneObjectGraph2.length !== 0) {
        filteredObjectGraph2.push(filterOneObjectGraph2[0]);
      }
      filteredActivities.push(filteredDataMonthWise[i].ACTIVITIES);

      filteredMinutes.push(filteredDataMonthWise[i].MINUTES);
    }
    filteredObjectGraph3.forEach((data) => {
      if (plotGraph3[data.ACTIVITY]) {
        plotGraph3[data.ACTIVITY] += data.COUNT_TOTAL;
      } else {
        plotGraph3[data.ACTIVITY] = data.COUNT_TOTAL;
      }
    });
    let temp = Object.entries(plotGraph3);

    temp = temp.sort((a, b) => b[1] - a[1]);
    console.log(temp, "temptemp");
    const t1 = temp.map((item) => item[0]);
    const t2 = temp.map((item) => item[1]);

    filteredObjectGraph2.forEach((data) => {
      const temp = Object.keys(data);
      temp.forEach((key) => {
        if (
          key === "COMPETITIVE" ||
          key === "COOPERATIVE" ||
          key === "GET_TO_KNOW" ||
          key === "TEAMWORK" ||
          key === "WELLNESS"
        ) {
          plotGraph2[key] += data[key];
        }
      });
    });
    console.log(
      plotGraph2,
      "plotGraph2plotGraph2plotGraph2plotGraph2plotGraph2plotGraph2plotGraph2plotGraph2plotGraph2"
    );

    labelsGraph3 = t1;
    plotValuesGraph3 = t2;
    // setOptionsGraph2({ labels: Object.keys(plotGraph2) });
    setSeriesGraph2([
      {
        data: Object.values(plotGraph2)
      }
    ]);
    setOptionsGraph3({
      ...optionsGraph3,
      xaxis: { ...optionsGraph3.xaxis, categories: labelsGraph3 }
    });
    setSeriesGraph3([
      {
        data: plotValuesGraph3
      }
    ]);

    const lastMonthStart = moment().subtract(1, "month").startOf("month");
    const lastMonthEnd = moment().subtract(1, "month").endOf("month");

    // Create an array of all dates in the last month
    let currentDate = moment(lastMonthStart);
    const datesInLastMonth = [];
    while (currentDate <= lastMonthEnd) {
      datesInLastMonth.push(currentDate.format("YYYY-MM-DD"));
      currentDate = currentDate.clone().add(1, "d");
    }

    // Filter out objects that don't have a DATE field in the last month's range
    const filteredData = filteredDataMonthWise.filter((item) => {
      return moment(item.DATE).isBetween(
        lastMonthStart,
        lastMonthEnd,
        null,
        "[]"
      );
    });

    // Create an array of all dates with an empty object for each date
    const lastMonthData = datesInLastMonth.map((date) => {
      const existingItem = filteredData.find((item) => item.DATE === date);
      return (
        existingItem || {
          DATE: date,
          ACTIVITIES: 0,
          MINUTES: 0,
          TEAM_CODE: "",
          TEAM_NAME: ""
        }
      );
    });
    console.log(
      lastMonthData,
      "lastMonthDatalastMonthDatalastMonthDatalastMonthData"
    );
    console.log(
      filteredDataMonthWise,
      "filteredDataMonthWisefilteredDataMonthWisefilteredDataMonthWise"
    );
    for (let i = 0; i < filteredDataMonthWise.length; i++) {
      let tempFiltered = moment(filteredDataMonthWise[i].DATE).format("MMM Do");
      console.log(
        tempFiltered,
        "tempFilteredtempFilteredtempFilteredtempFiltered"
      );
      filteredLables.push(tempFiltered);
    }
    console.log(filteredLables, "Labels=====>>>>month");

    setOptions({
      labels: lastMonthDates
    });
    const filteredActivitiesLastMonth = filteredActivities.map((element) =>
      element === undefined ? 0 : element
    );
    const filteredMinutesLastMonth = filteredMinutes.map((element) =>
      element === undefined ? 0 : element
    );
    const reverseFilteredActivitiesLastMonth = [
      ...filteredActivitiesLastMonth
    ].reverse();
    const reverseFilteredMinutesLastMonth = [
      ...filteredMinutesLastMonth
    ].reverse();
    console.log(
      reverseFilteredMinutesLastMonth,
      "reverseFilteredMinutesreverseFilteredMinutes333"
    );
    const activitiesArray = lastMonthData.map((item) => item.ACTIVITIES);
    const minutesArray = lastMonthData.map((item) => item.MINUTES);
    // setSeries(
    //   series.map((activity) => {
    //     if (activity.type === "column") {
    //       return { ...activity, data: reverseFilteredActivitiesLastMonth };
    //     } else {
    //       return { ...activity, data: reverseFilteredMinutesLastMonth };
    //     }
    //   })
    // );
    setSeries(
      series.map((activity) => {
        if (activity.type === "column") {
          return { ...activity, data: activitiesArray };
        } else {
          return { ...activity, data: minutesArray };
        }
      })
    );
  };

  const [options, setOptions] = useState({
    chart: {
      height: 350,
      type: "bar",
      stacked: false
    },
    stroke: {
      width: [0, 2, 5],
      curve: "smooth"
    },
    chart: {
      toolbar: {
        show: false
      }
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "dark",
        type: "horizontal",
        shadeIntensity: 0.5,
        gradientToColors: undefined,
        inverseColors: true,
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 50, 100],
        colorStops: []
      }
    },
    axisBorder: {
      show: false
    },
    axisTicks: {
      show: false
    },

    plotOptions: {
      bar: {
        columnWidth: "22%",
        borderRadius: 6,
        background: "#f00"
      }
    },

    grid: {
      strokeDashArray: 5,
      yaxis: {
        lines: {
          show: true
        }
      },
      xaxis: {
        lines: {
          show: true
        }
      }
    },

    fill: {
      colors: ["#E91E63"],
      // opacity: [0.85, 0.25, 1],
      opacity: [0.9],
      type: "solid",
      gradient: {
        shade: "dark",
        type: "horizontal",
        shadeIntensity: 0.5,
        gradientToColors: undefined,
        inverseColors: true,
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 50, 100],
        colorStops: []
      }
    },

    labels: [],

    dataLabels: {
      enabled: false
    },
    xaxis: {
      type: ""
    },
    yaxis: [
      {
        title: {
          text: "Activities"
        }
      },
      {
        opposite: true,
        title: {
          text: "Minutes"
        }
      }
    ]
  });

  const [series, setSeries] = useState([
    {
      color: "#08AF54",

      name: "Activities",
      type: "column",

      data: []
    },
    {
      color: "#EADC2D",
      name: "Minutes",
      type: "area",
      data: []
    }
  ]);

  const [optionsGraph2, setOptionsGraph2] = useState({
    chart: {
      width: "100%",
      type: "radar",
      toolbar: {
        show: false
      }
    },

    labels: [
      "COMPETITION",
      "COLLABORATION",
      "COMMUNICATION",
      "MISC",
      "WELLNESS"
    ],
    colors: ["#00cdcd", "#333"],
    states: {
      hover: {
        filter: {
          type: "none"
        }
      }
    },
    yaxis: {
      show: false
    },
    markers: {
      show: false,
      enabled: false
    },
    xaxis: {
      labels: {
        style: {
          colors: ["#25629d", "#25629d", "#25629d", "#25629d", "#25629d"],
          fontSize: "17px"
        }
      }
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["#00cdcd", "#333"],
      dashArray: 0
    },
    legend: {
      show: false
    },
    dataLabels: {
      enabled: false
    },
    fill: {
      colors: ["#00cdcd", "#333"]
    },
    tooltip: {
      enabled: true,
      theme: "dark"
    }
  });
  const [optionsGraph3, setOptionsGraph3] = useState({
    chart: {
      toolbar: {
        show: false
      }
    },
    tooltip: {
      enabled: false,
      style: {
        fontSize: "12px"
      },
      onDatasetHover: {
        title: "yugal",
        style: {
          fontSize: "12px"
        }
      },
      theme: "green"
    },
    xaxis: {
      categories: ["Activity", "Activity", "Activity", "Activity", "Activity"],
      show: true,
      labels: {
        show: true,
        style: {
          colors: ["#25629d", "#25629d", "#25629d", "#25629d", "#25629d"],
          fontSize: "12px"
        }
      },
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false
      }
    },
    yaxis: {
      show: true,
      color: "green",
      labels: {
        show: true,
        style: {
          colors: "#25629d",
          fontSize: "14px"
        }
      }
    },
    grid: {
      strokeDashArray: 5,
      yaxis: {
        lines: {
          show: true
        }
      },
      xaxis: {
        lines: {
          show: true
        }
      }
    },
    fill: {
      colors: ["#08AF54"]
    },
    dataLabels: {
      enabled: false
    },
    plotOptions: {
      bar: {
        horizontal: true,
        borderRadius: 8,
        columnWidth: "20px"
      }
    }
  });

  const [seriesGraph3, setSeriesGraph3] = useState([
    {
      // name: "Sales by age",
      data: []
    }
  ]);
  const [seriesGraph2, setSeriesGraph2] = useState([
    {
      data: []
    }
  ]);

  return (
    <>
      {/* <Header
        handleOptClick={handleOptClick}
        showInviteButton={showInviteButton}
        setShowInviteButton={setShowInviteButton}
        shareLinkModal={shareLinkModal}
        setShareLinkModal={setShareLinkModal}
        IviteLink={IviteLink}
        setIviteLink={setIviteLink}
        magicLinkState={magicLinkState}
        setmagicLinkState={setmagicLinkState}
        current_user={current_user}
        teamCode={teamCode}
      /> */}
      <Row className="team-row">
        <Col md={1} lg={1} className="p-0">
          <SideBarTabs
            showInviteButton={showInviteButton}
            setShowInviteButton={setShowInviteButton}
            shareLinkModal={shareLinkModal}
            setShareLinkModal={setShareLinkModal}
            IviteLink={IviteLink}
            setIviteLink={setIviteLink}
            magicLinkState={magicLinkState}
            setmagicLinkState={setmagicLinkState}
            current_user={current_user}
            teamCode={current_user?.team?.id}
            handleOptClick={handleOptClick}
          />
        </Col>
        <Col md={11} lg={11}>
          <div className="team-reports-wrapper">
            <div className="team-reports">
              <Container>
                <div className="team-reports-container">
                  <Breadcrumb>
                    <BreadcrumbItem>
                      <a href="/" className="link">
                        Game Library
                      </a>
                    </BreadcrumbItem>
                    <BreadcrumbItem className="link" active>
                      Reports
                    </BreadcrumbItem>
                  </Breadcrumb>
                  <h2 className="title">Team Reports</h2>
                  <p className="info">
                    Track team engagement, view suggestions, and improve your
                    team culture.{" "}
                  </p>
                  <div className="team-bg">
                    <img src={teamBg} alt="teamBg" />
                  </div>
                </div>
              </Container>
            </div>
            <Container>
              <Row className="card-row">
                <Col md={4} lg={4} xl={4} className="card-col">
                  {firstTopCard && (
                    <Card>
                      <div className="card-flex">
                        <img src={reportCardsTop[0]?.icon_url} alt="" />
                        <div className="card-content">
                          <div className="test">
                            <h4 className="card-title">
                              {reportCardsTop[0]?.title}
                            </h4>
                            <img
                              src={closeIcon}
                              onClick={() => setFirstTopCard(!firstTopCard)}
                              className="closeIcon"
                              alt=""
                            />
                          </div>
                          <p className="card-desc">
                            {reportCardsTop[0]?.text}{" "}
                            <a href={reportCardsTop[0]?.link_url}>
                              {reportCardsTop[0]?.link_label}
                            </a>
                          </p>
                        </div>
                      </div>
                    </Card>
                  )}
                </Col>
                <Col sm={6} md={4} lg={4} xl={4} className="card-col">
                  {secondTopCard && (
                    <Card>
                      <div className="card-flex">
                        <img src={reportCardsTop[1]?.icon_url} alt="" />
                        <div className="card-content">
                          <div className="test">
                            <h4 className="card-title">
                              {reportCardsTop[1]?.title}
                            </h4>
                            <img
                              src={closeIcon}
                              onClick={() => setSecondTopCard(!secondTopCard)}
                              className="closeIcon"
                              alt=""
                            />
                          </div>
                          <p className="card-desc">
                            {reportCardsTop[1]?.text}
                            <a href={reportCardsTop[1]?.link_url}>
                              {reportCardsTop[1]?.link_label}
                            </a>
                          </p>
                        </div>
                      </div>
                    </Card>
                  )}
                </Col>
                <Col sm={6} md={4} lg={4} xl={4} className="card-col">
                  {thirdTopCard && (
                    <Card>
                      <div className="card-flex">
                        <img src={reportCardsTop[2]?.icon_url} alt="" />
                        <div className="card-content">
                          <div className="test">
                            <h4 className="card-title">
                              {reportCardsTop[2]?.title}
                            </h4>
                            <img
                              src={closeIcon}
                              onClick={() => setThirdTopCard(!thirdTopCard)}
                              className="closeIcon"
                              alt=""
                            />
                          </div>
                          <p className="card-desc">
                            {reportCardsTop[2]?.text}{" "}
                            <a href={reportCardsTop[2]?.link_url}>
                              {reportCardsTop[2]?.link_label}
                            </a>
                          </p>
                        </div>
                      </div>
                    </Card>
                  )}
                </Col>
              </Row>
            </Container>

            <Container>
              <div className="team-filters">
                <div className="team-filters__flex">
                  <h2>Filter and Run Report</h2>
                  <div className="drop-div">
                    <div className="team-filters__dropdown">
                      <p className="name">{dropdownLabel}</p>
                      <div>
                        <img
                          onClick={() => {
                            setDropdownToggle(!dropdowntoggle);
                          }}
                          src={downArrow}
                          alt="down arrow"
                        />
                      </div>
                      {dropdowntoggle && (
                        <div className="menu">
                          <ul>
                            {datesDropdownArray &&
                              datesDropdownArray.map((element) => {
                                return (
                                  <li
                                    onClick={() => handleClickDropdown(element)}
                                  >
                                    {element}
                                  </li>
                                );
                              })}
                          </ul>
                        </div>
                      )}
                    </div>
                    <button
                      onClick={() => filterDates(dropdownLabel)}
                      className="run-btn"
                    >
                      Run
                    </button>
                  </div>
                </div>
              </div>
            </Container>

            <Container>
              <section className="culture-building-graph">
                <div className="team-name">
                  <h3 className="name-txt">
                    {apiData[0]?.CUSTDB_ENGAGEMENT[0]?.TEAM_NAME} Culture
                    Building Engagement - All
                  </h3>
                </div>
                <div className="graph-here">
                  <div className="wrap">
                    <Chart
                      options={options}
                      series={series}
                      type="bar"
                      // width={1000}
                      height="400px"
                    />
                  </div>
                </div>
              </section>
            </Container>
            <Container className="team-reports-container">
              <Row>
                <Col lg={6} xl={6}>
                  <div className="graph-section">
                    <div className="graph-section-header">
                      <h3>Culture Categories - All</h3>
                    </div>
                    <div className="graph-here">
                      {/* <Button>Export</Button> */}
                      <Chart
                        options={optionsGraph2}
                        series={seriesGraph2}
                        type="radar"
                        width="100%"
                        height="400px"
                      />
                    </div>
                  </div>
                </Col>
                <Col lg={6} xl={6}>
                  <div className="graph-section">
                    <div className="graph-section-header">
                      <h3>Team Favorites - All</h3>
                    </div>
                    <div className="graph-here">
                      <Chart
                        options={optionsGraph3}
                        series={seriesGraph3}
                        type="bar"
                        width="100%"
                        height="400px"
                      />
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
            <Container>
              <div className="tr-wrapper">
                <div className="team-acitivity">
                  <p className="txt">
                    <strong>Team Activity</strong>
                  </p>
                  {/* <Button onClick={() => handleExport()} className="export-btn"> */}
                  <Button onClick={() => handleExport()} className="export-btn">
                    Export
                  </Button>
                </div>
                <div className="tr-header">
                  <Table responsive className="table-header">
                    <thead>
                      <tr>
                        <th className="head">Teammate</th>
                        <th className="head"># of Activites</th>
                        <th className="head">Total Time Spent</th>
                        <th className="head">Last Activity</th>
                        <th className="head last-head"></th>
                      </tr>
                    </thead>
                  </Table>
                </div>

                <div className="table-main">
                  <Table responsive className="table-data">
                    <thead>
                      {Object.entries(membersObject) &&
                        Object.entries(membersObject)?.length > 0 &&
                        Object.entries(membersObject).map((user) => {
                          return (
                            <tr>
                              <td className="data">
                                <div className="team-user">
                                  <div className="profile-img">
                                    <img src={user[1].PROFILE_IMG} alt="" />
                                  </div>
                                  <div className="profile-name">
                                    <h4 className="txt">{user[0]}</h4>
                                  </div>
                                </div>
                              </td>
                              <td className="data">{user[1].ACTIVITIES_RAW}</td>
                              <td className="data">{user[1].TIME_RAW}</td>
                              <td className="data">{user[1].LAST_ACTIVITY}</td>
                              <td className="data">
                                <img
                                  src={threeDots}
                                  className="three-dots"
                                  alt="three dots"
                                />
                              </td>
                            </tr>
                          );
                        })}
                    </thead>
                  </Table>
                </div>
              </div>
            </Container>
          </div>
        </Col>
      </Row>
    </>
  );
};
const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer
});

const mapDispatchToProps = (dispatch) => {
  return {
    set_team_opts: (data) => dispatch(optAction.set_team_opts(data)),
    setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data))
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(TeamReports);
